
<section class="breadcrumb-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb-title">
            <h1>Thank You</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
    <ul class="breadcrumb">
      <li><a routerLink="/">Home</a></li>
      <li><i class="fa fa-angle-double-right"></i></li>
      <li>Thank You</li>
    </ul>
  <section class="section-lg std-scholarship">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-md-5">
              <div class="sec-title text-center" >
                <h2>Thank<span> You</span></h2>
                <div class="text-line"></div>
              </div>
              <div class="text-center" >
                <h4>Thank You for Submitting your Qquery and We Will Reply to you very soon.</h4>
                <div class="text-center mt-3">
                  <a class="button-text" routerLink="/">Go Back to Home</a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="text-center" >
                <img src="assets/images/thank-you.jpg" class="img-fluid" alt="Thank You | Ghrcacsn" title="Thank You | Ghrcacsn">
              </div>
            </div>
          </div>
    </div>
  </section>
  